import { UploadCloud, X } from 'lucide-react'
import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { productImageUrl } from '../lib/images'

export function AdminImageUpload({ value, onChange, folder = 'content', label = 'Imagem' }: { value: string | null; onChange: (path: string | null) => void; folder?: string; label?: string }) {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  const upload = async (file: File) => {
    setUploading(true); setError('')
    try {
      const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg'
      const path = `${folder}/${crypto.randomUUID()}.${ext}`
      const { error: uploadError } = await supabase.storage.from('product-images').upload(path, file, { upsert: false, cacheControl: '3600' })
      if (uploadError) throw uploadError
      onChange(path)
    } catch (err) { setError(err instanceof Error ? err.message : 'Falha no upload.') }
    finally { setUploading(false) }
  }

  return (
    <div className="admin-upload">
      <label>{label}</label>
      {value ? <div className="admin-upload__preview"><img src={productImageUrl(value)} alt="" /><button type="button" onClick={() => onChange(null)}><X size={16} /></button></div> : (
        <label className="admin-upload__drop"><UploadCloud /><span>{uploading ? 'Enviando...' : 'Selecionar imagem'}</span><input type="file" accept="image/jpeg,image/png,image/webp,image/avif" disabled={uploading} onChange={e => e.target.files?.[0] && upload(e.target.files[0])} /></label>
      )}
      {error && <small className="form-error">{error}</small>}
    </div>
  )
}
